/**
 * Wize Messaging REST API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface UpdateUserPresenceRequest { 
    /**
     * Presence state
     */
    status?: UpdateUserPresenceRequest.StatusEnum;
    /**
     * Presence state description
     */
    desc?: string;
}
export namespace UpdateUserPresenceRequest {
    export const StatusEnum = {
        AVAILABLE: 'AVAILABLE',
        OFF_LINE: 'OFF_LINE'
    } as const;
    export type StatusEnum = typeof StatusEnum[keyof typeof StatusEnum];
}


